import React, { Component, Suspense, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import errorReporter from '../../../Admin/utility/errorReporter';
import ErrorFallBack from '../../../Admin/containers/ErrorFallBack/ErrorFallBack';
//import CheckoutConverge from '../Shop/Checkout/CheckoutConverge'
import Page404 from '../ErrorPages/Page404'
import * as actionCreators from '../../../store/actions/index';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ServiceProvider } from '../../../providers/ServiceContext'
import Layout from '../../components/Layout/Layout'
import { Route, Switch } from 'react-router-dom';
import { SettingsProvider } from '../../../providers/SettingsProvider';
import { SalesEquipmentProvider } from '../../../providers/SalesEquipmentContext';
import { ProductProvider } from '../../../providers/ProductContext';
import { ThemesProvider } from '../../../providers/ThemesContext';
import CheckoutComplete from '../../components/Checkout/CheckoutComplete/CheckoutComplete';

import Checkout from '../Shop/Checkout/Checkout';


class Public extends Component {

    render() {

        const Home = lazy(() => import('../Home/Home'));
        const Shop = lazy(() => import('../Shop/Shop'));
        const Product = lazy(() => import('../Shop/Product/Product'));
        const Equipment = lazy(() => import('../Equipment/Equipment'));
        const Contact = lazy(() => import('../Contact/Contact'));
        const Privacy = lazy(() => import('../Privacy/Privacy'));
        const Accessibility = lazy(() => import('../Accessibility/Accessibility'));
        const CareerContainer  = lazy(() => import('../Careers/CareerContainer'));
        const Services  = lazy(() => import('../Services/Services'));
        const Orders  = lazy(() => import('../Orders/Orders'));
        const Cart = lazy(() => import('../Shop/Cart/Cart'));
        const History = lazy(() => import('../History/History'));

        return (
            <ThemesProvider>
                <SettingsProvider>
                    <Layout
                        cart={this.props.cart}
                        addedToCart={this.props.addedToCart}
                        clearIsAdded={this.props.clearIsAdded}
                    >
                        <SalesEquipmentProvider>
                            <ProductProvider>
                                <ServiceProvider>
                                <Suspense fallback={<div>Loading...</div>}>

                                    <ErrorBoundary fallback={<ErrorFallBack/>} onError={(error) => {errorReporter(error, this.props.location)}} key={this.props.location.pathname}>
                                        <Switch>
                                            <Route path="/" exact><Home /></Route>
                                            <Route path="/shop" exact component={Shop} />
                                            <Route path="/services" component={Services} />
                                            <Route path="/careers" exact component={CareerContainer} />
                                            <Route path="/orders/:order" exact component={Orders} />
                                            <Route path="/contact" exact component={Contact} />
                                            <Route path="/shop/products/:product" component={Product} />
                                            <Route path="/cart" exact component={Cart} />
                                            <Route path="/cart/checkout" exact component={Checkout} />
                                            {/*<Route path="/cart/checkout" exact component={CheckoutConverge} />*/}
                                            <Route path="/cart/checkout/complete" exact component={CheckoutComplete} />
                                            <Route path="/equipment" exact component={Equipment} />
                                            <Route path="/privacy" exact component={Privacy} />
                                            <Route path="/accessibility" exact component={Accessibility} />
                                            <Route path="/history" exact component={History} />
                                            <Route path="/" component={Page404} />
                                        </Switch>
                                    </ErrorBoundary>

                                </Suspense>
                                </ServiceProvider>
                            </ProductProvider>
                        </SalesEquipmentProvider>
                    </Layout >
                </SettingsProvider>
            </ThemesProvider>
        );
    };
};

const mapStateToProps = state => {
    return {
        cart: state.cart.cart,
        addedToCart: state.cart.addedToCart,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        clearIsAdded: () => dispatch(actionCreators.clearIsAdded()),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Public));